import { Actions } from 'enums/gladlyapi';
import uiEvents from 'events/ui';
import showWidget from 'actions/ui/showWidget';
import hideCustomMinimizedButton from 'app/dom_mutators/hideCustomMinimizedButton';
import { getIsVisible } from 'app/modules';
import updateClientUnreadButton from 'app/dom_mutators/updateClientUnreadButton';

export const gladlyApiShow = () => {
  return (dispatch, getState) => {
    const state = getState();

    dispatch(uiEvents.unsuppress());
    dispatch(uiEvents.unminimizeWidget());
    dispatch(showWidget());

    // mark all msgs as read and hide client's custom minimized button if one exists
    updateClientUnreadButton(0);
    hideCustomMinimizedButton();

    const isVisible = getIsVisible(state);
    dispatch({ type: Actions.GLADLY_API_SHOW, payload: { isVisible } });
  };
};
